/* eslint-disable */
import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Col, Form, Input, InputNumber, message, Row, Select, Spin, Typography } from 'antd'
import { fetchJStoreList } from '@/redux/components/getJStoreListSlice'
import { fetchJPositionList } from '@/redux/components/getJPositionListSlice'
import { fetchJDepartmentList } from '@/redux/components/getJDepartmentListSlice'
import { getSystemAgentDetail } from '@/service/systemControl'

const { Title, Text } = Typography

const AGENT_TYPE_OPTIONS = [
  { value: 1, label: '超级管理员' },
  { value: 2, label: '员工' }
]

const LOGIN_PERMISSION_OPTIONS = [
  { value: 1, label: '允许登录' },
  { value: 2, label: '禁止登录' }
]

const AGENT_STATE_OPTIONS = [
  { value: 1, label: '在职' },
  { value: 2, label: '离职' },
  { value: 3, label: '调店' }
]

/** 列表行数据与 GET /system/agents/{id} 合并，详情优先 */
function mergeAgentDetailForForm(rowRecord, detail) {
  if (!detail || typeof detail !== 'object') return rowRecord || {}
  return { ...rowRecord, ...detail }
}

/** 分节标题：区块间距便于长表单扫读 */
const SectionTitle = ({ children, first }) => (
  <div style={{ marginTop: first ? 0 : 20, marginBottom: 12 }}>
    <Title level={5} style={{ margin: 0, fontSize: 15, fontWeight: 600 }}>
      {children}
    </Title>
    {first ? (
      <Text type="secondary" style={{ fontSize: 12, display: 'block', marginTop: 4 }}>
        选填项可留空；未填写的内容不会提交到接口
      </Text>
    ) : null}
  </div>
)

const mapStateToProps = (state) => ({
  jStoreList: state.components.getJStoreList,
  getJPositionList: state.components.getJPositionList,
  getJDepartmentList: state.components.getJDepartmentList
})

const mapDispatchToProps = {
  fetchJStoreList,
  fetchJPositionList,
  fetchJDepartmentList
}

class AgentForm extends React.Component {
  static propTypes = {
    form: PropTypes.object,
    actType: PropTypes.oneOf(['create', 'edit']),
    initialRecord: PropTypes.object,
    jStoreList: PropTypes.object,
    getJPositionList: PropTypes.object,
    getJDepartmentList: PropTypes.object,
    fetchJStoreList: PropTypes.func,
    fetchJPositionList: PropTypes.func,
    fetchJDepartmentList: PropTypes.func
  }

  static defaultProps = {
    actType: 'create'
  }

  state = {
    detailLoading: false
  }

  /** 按门店拉 /common/department */
  loadDepartmentOptions = (storeId) => {
    const { fetchJDepartmentList } = this.props
    const q =
      storeId != null && storeId !== '' ? { storeId: String(storeId) } : {}
    fetchJDepartmentList({ query: q, dataType: 'option' })
  }

  /**
   * /common/position：有部门时传 storeId + deptId；仅门店时只传 storeId（与列表筛选项一致）
   */
  loadPositionOptions = (storeId, departmentId) => {
    const { fetchJPositionList } = this.props
    const hasStore = storeId != null && storeId !== ''
    if (!hasStore) {
      fetchJPositionList({ query: {}, dataType: 'option' })
      return
    }
    const q = { storeId: String(storeId) }
    if (departmentId != null && departmentId !== '') {
      q.deptId = String(departmentId)
    }
    fetchJPositionList({ query: q, dataType: 'option' })
  }

  loadDeptAndPositionOptions = (storeId, departmentId) => {
    this.loadDepartmentOptions(storeId)
    this.loadPositionOptions(storeId, departmentId)
  }

  componentDidMount() {
    const { jStoreList, fetchJStoreList: load, initialRecord, actType } = this.props
    const after = async () => {
      if (actType === 'edit' && initialRecord && initialRecord.id != null) {
        this.setState({ detailLoading: true })
        let effective = initialRecord
        try {
          const res = await getSystemAgentDetail(initialRecord.id)
          effective = mergeAgentDetailForForm(initialRecord, res.data)
        } catch (e) {
          const msg =
            e?.response?.data?.msg ||
            e?.response?.data?.message ||
            e?.message ||
            '加载员工详情失败'
          message.error(typeof msg === 'string' ? msg : '加载员工详情失败')
        }
        this.setState({ detailLoading: false })
        this.loadDeptAndPositionOptions(effective?.storeId, effective?.departmentId)
        this.applyRecord(effective)
        return
      }
      const initialStoreId =
        actType === 'edit' && initialRecord ? initialRecord.storeId : undefined
      this.loadDeptAndPositionOptions(
        initialStoreId,
        actType === 'edit' && initialRecord ? initialRecord.departmentId : undefined
      )
      if (actType === 'edit' && initialRecord) {
        this.applyRecord(initialRecord)
      }
    }
    const data = jStoreList?.data
    if (!data || data.length === 0) {
      load({ query: {}, dataType: 'option' }).finally(() => {
        after()
      })
    } else {
      after()
    }
  }

  componentDidUpdate(prevProps) {
    const { actType, initialRecord } = this.props
    if (
      actType === 'edit' &&
      initialRecord &&
      prevProps.initialRecord !== initialRecord
    ) {
      if (initialRecord.id != null) {
        this.setState({ detailLoading: true })
        getSystemAgentDetail(initialRecord.id)
          .then((res) => {
            const effective = mergeAgentDetailForForm(initialRecord, res.data)
            this.loadDeptAndPositionOptions(effective?.storeId, effective?.departmentId)
            this.applyRecord(effective)
          })
          .catch((e) => {
            const msg =
              e?.response?.data?.msg ||
              e?.response?.data?.message ||
              e?.message ||
              '加载员工详情失败'
            message.error(typeof msg === 'string' ? msg : '加载员工详情失败')
            this.loadDeptAndPositionOptions(initialRecord.storeId, initialRecord.departmentId)
            this.applyRecord(initialRecord)
          })
          .finally(() => this.setState({ detailLoading: false }))
      } else {
        this.loadDeptAndPositionOptions(initialRecord.storeId, initialRecord.departmentId)
        this.applyRecord(initialRecord)
      }
    }
  }

  /** 编辑回填：支持列表行或 GET /system/agents/{id} 合并后的对象；兼容 isAllowedLogin */
  applyRecord = (r) => {
    const { form, actType } = this.props
    if (!r || !form?.current || actType !== 'edit') return
    let loginPermission = 1
    if (r.loginPermission != null) {
      loginPermission = Number(r.loginPermission)
    } else if (typeof r.isAllowedLogin === 'boolean') {
      loginPermission = r.isAllowedLogin ? 1 : 2
    }
    form.current.setFieldsValue({
      storeId: r.storeId != null ? Number(r.storeId) : undefined,
      account: r.account,
      userName: r.userName,
      companyName: r.companyName,
      phone: r.phone,
      qqOrWechat: r.qqOrWechat,
      provinceId: r.provinceId != null ? Number(r.provinceId) : undefined,
      cityId: r.cityId != null ? Number(r.cityId) : undefined,
      areaId: r.areaId != null ? Number(r.areaId) : undefined,
      address: r.address,
      departmentId: r.departmentId != null ? Number(r.departmentId) : undefined,
      positionId: r.positionId != null ? Number(r.positionId) : undefined,
      type: r.type != null ? Number(r.type) : 2,
      loginPermission,
      state: r.state != null ? Number(r.state) : 1,
      dingUserId: r.dingUserId != null ? String(r.dingUserId) : r.openId != null ? String(r.openId) : undefined,
      password: undefined
    })
  }

  render() {
    const { form, actType, jStoreList, getJPositionList, getJDepartmentList } = this.props
    const { detailLoading } = this.state
    const isEdit = actType === 'edit'
    const storeOptions = (jStoreList?.data || []).map((o) => ({
      value: Number(o.id),
      label: o.value
    }))
    const { data: positionSelectData = [] } = getJPositionList
    const { data: departmentSelectData = [] } = getJDepartmentList
    const positionOptions = positionSelectData.map((o) => ({
      value: Number(o.id),
      label: o.value
    }))
    const departmentOptions = departmentSelectData.map((o) => ({
      value: Number(o.id),
      label: o.value
    }))

    const rowGutter = [16, 4]
    const colSpan = { xs: 24, sm: 12, lg: 8 }

    return (
      <Spin spinning={isEdit && detailLoading} tip="加载员工详情…">
      <Form
        ref={form}
        layout="vertical"
        requiredMark={true}
        style={{ width: '100%', maxWidth: '100%', paddingBottom: 8 }}
        initialValues={
          isEdit
            ? undefined
            : {
                type: 2,
                loginPermission: 1,
                state: 1
              }
        }
      >
        <SectionTitle first>账号与登录</SectionTitle>
        <Row gutter={rowGutter} wrap>
          <Col {...colSpan}>
            <Form.Item
              label="登录账号"
              name="account"
              rules={[{ required: true, message: '请输入登录账号' }]}
            >
              <Input placeholder="登录用账号" allowClear maxLength={128} disabled={isEdit} />
            </Form.Item>
          </Col>
          <Col {...colSpan}>
            <Form.Item
              label="密码"
              name="password"
              rules={
                isEdit
                  ? []
                  : [{ required: true, message: '请输入密码' }]
              }
            >
              <Input.Password placeholder={isEdit ? '不修改请留空' : '创建时必填'} allowClear />
            </Form.Item>
          </Col>
          <Col {...colSpan}>
            <Form.Item
              label="用户类型"
              name="type"
              rules={[{ required: true, message: '请选择用户类型' }]}
            >
              <Select allowClear={false} placeholder="请选择" options={AGENT_TYPE_OPTIONS} />
            </Form.Item>
          </Col>
          <Col {...colSpan}>
            <Form.Item label="登录许可" name="loginPermission">
              <Select allowClear placeholder="默认允许" options={LOGIN_PERMISSION_OPTIONS} />
            </Form.Item>
          </Col>
          <Col {...colSpan}>
            <Form.Item label="在职状态" name="state">
              <Select allowClear placeholder="默认在职" options={AGENT_STATE_OPTIONS} />
            </Form.Item>
          </Col>
        </Row>

        <SectionTitle>门店与组织</SectionTitle>
        <Row gutter={rowGutter} wrap>
          <Col {...colSpan}>
            <Form.Item label="门店" name="storeId">
              <Select
                allowClear
                placeholder="未选表示不按门店限制"
                options={storeOptions}
                showSearch
                optionFilterProp="label"
                onChange={(v) => {
                  this.loadDeptAndPositionOptions(v, undefined)
                  const { form: f } = this.props
                  if (f?.current) {
                    f.current.setFieldsValue({
                      departmentId: undefined,
                      positionId: undefined
                    })
                  }
                }}
              />
            </Form.Item>
          </Col>
          <Col {...colSpan}>
            <Form.Item label="部门" name="departmentId">
              <Select
                allowClear
                placeholder="选填"
                options={departmentOptions}
                showSearch
                optionFilterProp="label"
                onChange={(deptId) => {
                  const storeId = this.props.form?.current?.getFieldValue('storeId')
                  this.loadPositionOptions(storeId, deptId)
                  const { form: f } = this.props
                  if (f?.current) {
                    f.current.setFieldsValue({ positionId: undefined })
                  }
                }}
              />
            </Form.Item>
          </Col>
          <Col {...colSpan}>
            <Form.Item label="职位" name="positionId">
              <Select
                allowClear
                placeholder="选填"
                options={positionOptions}
                showSearch
                optionFilterProp="label"
              />
            </Form.Item>
          </Col>
        </Row>

        <SectionTitle>个人信息</SectionTitle>
        <Row gutter={rowGutter} wrap>
          <Col {...colSpan}>
            <Form.Item
              label="用户名"
              name="userName"
              rules={[{ required: true, message: '请输入用户名' }]}
              tooltip="真实姓名"
            >
              <Input placeholder="真实姓名" allowClear maxLength={64} />
            </Form.Item>
          </Col>
          <Col {...colSpan}>
            <Form.Item label="公司名称" name="companyName">
              <Input placeholder="选填" allowClear maxLength={128} />
            </Form.Item>
          </Col>
          <Col {...colSpan}>
            <Form.Item label="手机号" name="phone">
              <Input placeholder="选填" allowClear maxLength={20} />
            </Form.Item>
          </Col>
          <Col {...colSpan}>
            <Form.Item label="QQ / 微信" name="qqOrWechat">
              <Input placeholder="选填" allowClear maxLength={64} />
            </Form.Item>
          </Col>
          <Col {...colSpan}>
            <Form.Item label="钉钉 ID" name="dingUserId" tooltip="员工钉钉 OpenId；由系统同步，不可在此修改">
              <Input readOnly placeholder="暂无" maxLength={128} />
            </Form.Item>
          </Col>
        </Row>

        <SectionTitle>地区与地址</SectionTitle>
        <Row gutter={rowGutter} wrap>
          <Col xs={24} sm={8}>
            <Form.Item label="省份 ID" name="provinceId">
              <InputNumber style={{ width: '100%' }} min={0} placeholder="行政区划编码" />
            </Form.Item>
          </Col>
          <Col xs={24} sm={8}>
            <Form.Item label="城市 ID" name="cityId">
              <InputNumber style={{ width: '100%' }} min={0} placeholder="行政区划编码" />
            </Form.Item>
          </Col>
          <Col xs={24} sm={8}>
            <Form.Item label="区域 ID" name="areaId">
              <InputNumber style={{ width: '100%' }} min={0} placeholder="行政区划编码" />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item label="详细地址" name="address">
              <Input.TextArea rows={2} placeholder="街道、门牌等" allowClear maxLength={255} showCount />
            </Form.Item>
          </Col>
        </Row>
      </Form>
      </Spin>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AgentForm)
